const BASE_HINT_PREFIX = 'admonition';
export const BASE_UTILS_PREFIX = 'docutils container';
export const BASE_HTTP_PREFIX = 'http';
const BASE_TABLE_PREFIX = 'colwidths-given';
const TABS_PREFIX = 'sphinx-tabs';
const DOC_UTILS_ALIGN = 'docutils align';
const TABLE_ALIGN_DEFAULT = `${DOC_UTILS_ALIGN}-default`;

export const DYNAMIC_CONTENT_CLASS_NAMES = {
  hint: `${BASE_HINT_PREFIX} hint`,
  note: `${BASE_HINT_PREFIX} note`,
  attention: `${BASE_HINT_PREFIX} attention`,
  seealso: `${BASE_HINT_PREFIX} seealso`,
  highlight: 'highlight',
  ol: 'arabic',
  section: 'section',
  guilabel: 'guilabel',
  menuselection: 'menuselection',
  tabs: `${TABS_PREFIX} ${BASE_UTILS_PREFIX}`,
  tabHeader: `${TABS_PREFIX}-tab`,
  tabContent: `${TABS_PREFIX}-panel`,
  table: BASE_TABLE_PREFIX,
  tableLeft: `${BASE_TABLE_PREFIX} ${DOC_UTILS_ALIGN}-left`,
  tableDefault: `${BASE_TABLE_PREFIX} ${TABLE_ALIGN_DEFAULT}`,
  tableCenter: `${BASE_TABLE_PREFIX} ${DOC_UTILS_ALIGN}-center`,
  baseTableAlignCenter: `${DOC_UTILS_ALIGN}-center`,
  baseTableAlignLeft: `${DOC_UTILS_ALIGN}-left`,
  baseTableAlignDefault: `${DOC_UTILS_ALIGN}-default`,
  codeBlockCaption: 'code-block-caption',
  http: BASE_HTTP_PREFIX,
  httpGet: `${BASE_HTTP_PREFIX} get`,
  httpPost: `${BASE_HTTP_PREFIX} post`,
  httpPut: `${BASE_HTTP_PREFIX} put`,
  httpDelete: `${BASE_HTTP_PREFIX} delete`,
  httpOption: `${BASE_HTTP_PREFIX} option`,
  fieldList: 'field-list simple',
  serviceCardsWrapper: `service-cards search-by-service-disabled ${BASE_UTILS_PREFIX}`,
  serviceCard: `service-card ${BASE_UTILS_PREFIX}`,
  serviceCardTitle: `service-card-header ${BASE_UTILS_PREFIX}`,
  serviceCardDescription: `service-card-text ${BASE_UTILS_PREFIX}`,
  glossaryItem: 'xref std std-term',
  boldP: 'rubric',
  toggleGroup: 'toggle-group',
  command: 'command',
  math: 'math',
} as const;

export const geAccordionClassname = (prefix: 'header' | 'content') => `toggle-${prefix} ${BASE_UTILS_PREFIX}`;

export const HTTP_CLASS_NAMES = [
  DYNAMIC_CONTENT_CLASS_NAMES.httpPut,
  DYNAMIC_CONTENT_CLASS_NAMES.httpGet,
  DYNAMIC_CONTENT_CLASS_NAMES.httpDelete,
  DYNAMIC_CONTENT_CLASS_NAMES.httpPost,
  DYNAMIC_CONTENT_CLASS_NAMES.httpOption,
] as const;

export const TABLE_CENTER_NAMES = [
  DYNAMIC_CONTENT_CLASS_NAMES.baseTableAlignCenter,
  DYNAMIC_CONTENT_CLASS_NAMES.tableCenter,
];

export const SPECS_PATH_IDENTIFIERS = {
  specs: '_specs',
  static: '_static',
  download: '_downloads',
};

export const SPECS_EXTS = {
  yaml: 'yaml',
  yml: 'yml',
  json: 'json',
  proto: 'proto',
};
